import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
// TypeScript declaration for Meta Pixel
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    _fbq?: any;
  }
}
const META_PIXEL_ID = '1349588510210844';
export function App() {
  useEffect(() => {
    // Inject Meta Pixel script
    if (typeof window === 'undefined') return;
    if (window.fbq) {
      // Already initialized, just fire PageView
      window.fbq('track', 'PageView');
      return;
    }
    // Standard Meta Pixel base code
    ;
    (function (f: any, b, e, v, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', undefined, undefined, undefined);
    window.fbq?.('init', META_PIXEL_ID);
    window.fbq?.('track', 'PageView');
  }, []);
  return <LandingPage data-id="element-0" />;
}